import * as Scrivito from "scrivito";
import ImageOrVideo from "../../Components/ImageOrVideo";

export const TextImagePanelWidgetComponent = Scrivito.connect(({ widget }) => {
  const destination = widget.get("destination");

  const Teaser = () => (
    <>
      <ImageOrVideo
        widget={widget}
        teaser={true}
        className="teaser-box__image"
      />
      <div className="teaser-box-content">
        <Scrivito.ContentTag
          content={widget}
          attribute="headline"
          tag="h4"
          className="teaser-box__title"
        />
        <Scrivito.ContentTag
          content={widget}
          attribute="content"
          tag="div"
          className="teaser-box__description"
        />
        {destination && (
          <span className="teaser-box__button">
            <i className="las la-angle-right me-2"></i>
            {destination.title() || "Show More"}
          </span>
        )}
      </div>
    </>
  );

  if (destination) {
    return (
      <Scrivito.WidgetTag className="teaser-box h-100 --event">
        <Scrivito.LinkTag
          to={destination}
          className="teaser-box__wrapper d-block bg-white"
        >
          <Teaser />
        </Scrivito.LinkTag>
      </Scrivito.WidgetTag>
    );
  }

  return (
    <Scrivito.WidgetTag className="teaser-box h-100 --panel">
      <Teaser />
    </Scrivito.WidgetTag>
  );
});

Scrivito.provideComponent(
  "TextImagePanelWidget",
  TextImagePanelWidgetComponent
);
